import { render, staticRenderFns } from "./InfoCarriersQuoteResponsive.vue?vue&type=template&id=88b7e48e&scoped=true"
import script from "./InfoCarriersQuoteResponsive.vue?vue&type=script&lang=js"
export * from "./InfoCarriersQuoteResponsive.vue?vue&type=script&lang=js"
import style0 from "./InfoCarriersQuoteResponsive.vue?vue&type=style&index=0&id=88b7e48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7e48e",
  null
  
)

export default component.exports